import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type SelectorFooterProps = ComponentProps<"div">

function SelectorFooter(props: SelectorFooterProps) {
  const { className, ...divProps } = props
  return <div className={cn("selector-footer", className)} {...divProps} />
}

export default SelectorFooter
